import LogoutViewModelT from '@/ViewModels/Views/LogoutViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class LogoutViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private LogoutViewModel: any;
    private LogoutView: any;
    constructor(params: any) {
        super(params);
        this.LogoutViewModel = ComponentManager.getViewModel<typeof LogoutViewModelT>('LogoutViewModel');
        this.LogoutView = ComponentManager.getView('LogoutView');
    }
    public getRegion(): string {
        return 'Modal';
    }
    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.LogoutViewModel({ viewFactory: this });
        }
        if (this.view == null) {
            this.view = new this.LogoutView(this.viewModel, this.createRootElement('Logout'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
    public getNecessaryRedirect(): any {
        return false;
    }
}

ComponentManager.setFactory('Logout', LogoutViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('LOGOUT', LogoutViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');